/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AcceptVisitRequestResponseUpdatedVisit } from './AcceptVisitRequestResponseUpdatedVisit';
import {
    AcceptVisitRequestResponseUpdatedVisitFromJSON,
    AcceptVisitRequestResponseUpdatedVisitFromJSONTyped,
    AcceptVisitRequestResponseUpdatedVisitToJSON,
} from './AcceptVisitRequestResponseUpdatedVisit';

/**
 * Response after accepting a visit request.
 * @export
 * @interface AcceptVisitRequestResponse
 */
export interface AcceptVisitRequestResponse {
    /**
     * 
     * @type {string}
     * @memberof AcceptVisitRequestResponse
     */
    status: string;
    /**
     * 
     * @type {AcceptVisitRequestResponseUpdatedVisit}
     * @memberof AcceptVisitRequestResponse
     */
    updatedVisit?: AcceptVisitRequestResponseUpdatedVisit;
    /**
     * 
     * @type {Error}
     * @memberof AcceptVisitRequestResponse
     */
    error?: Error;
}

/**
 * Check if a given object implements the AcceptVisitRequestResponse interface.
 */
export function instanceOfAcceptVisitRequestResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function AcceptVisitRequestResponseFromJSON(json: any): AcceptVisitRequestResponse {
    return AcceptVisitRequestResponseFromJSONTyped(json, false);
}

export function AcceptVisitRequestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptVisitRequestResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'updatedVisit': !exists(json, 'updated_visit') ? undefined : AcceptVisitRequestResponseUpdatedVisitFromJSON(json['updated_visit']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function AcceptVisitRequestResponseToJSON(value?: AcceptVisitRequestResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'updated_visit': AcceptVisitRequestResponseUpdatedVisitToJSON(value.updatedVisit),
        'error': value.error,
    };
}

